<!--  -->
<template>
  <div class="container">
    <img
      src="../../assets/credential/credential6.jpg"
      alt="营业执照"
      v-if="pageType == 1"
    />
    <img
      src="../../assets/credential/credential2.jpg"
      alt="互联网药品信息服务备案凭证：粤网药信备字(2025)第00579号"
      v-if="pageType == 2"
    />
    <img
      src="../../assets/credential/credential5.jpg"
      alt=" 医疗器械网络销售备案公示"
      v-if="pageType == 3"
    />
    <img
      class="rotate"
      src="../../assets/register/licesence-01_rotated.jpg"
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
     <img
      src="../../assets/register/licesence-02.jpg"
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
      <img
       class="rotate"
      src="../../assets/register/licesence-03_rotated.jpg"
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
      <img
      src="../../assets/register/licesence-04.jpg"
      alt="广州默尼医疗技术有限公司 资质文件"
      v-if="pageType == 4"
    />
   <img
      src="../../assets/credential/credential5.jpg"
      alt=" 医疗器械网络销售备案公示"
      v-if="pageType == 5"
    />
    <img
      src="../../assets/credential/credential1.jpg"
      alt="第二类医疗器械经营备案凭证"
      v-if="pageType == 6"
    />
     <img
      src="../../assets/credential/credential4.jpg"
      alt="医疗器械网络交易服务第三方备案凭证"
      v-if="pageType == 8"
    />
     <img
      src="../../assets/credential/credential3.jpg"
      alt="仅销售预包装食品备案"
      v-if="pageType == 7"
    />
  </div> 
</template>

<script>
export default {
  name: "",
  data() {
    return {
      pageType: 1
    };
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created() {
    if (this.$route.query.pageType) {
      this.pageType = this.$route.query.pageType;
    }
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 30px;

  img {
    max-width: 80vw;
  }
 .rotate {
 }
}

</style>


// WEBPACK FOOTER //
// src/pages/license/license.vue